import { render, staticRenderFns } from "./TableForm20.vue?vue&type=template&id=71c395ff&scoped=true"
import script from "./TableForm20.vue?vue&type=script&lang=ts"
export * from "./TableForm20.vue?vue&type=script&lang=ts"
import style0 from "./TableForm20.vue?vue&type=style&index=0&id=71c395ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c395ff",
  null
  
)

export default component.exports